/* eslint-env browser */

LazyLoad(document.querySelectorAll('.lazy'))

export function LazyLoad (images) {
  let lazyloadCount = images.length

  const imageObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        var image = entry.target
        loadImage(image)
        imageObserver.unobserve(image)
        lazyloadCount--

        if (lazyloadCount <= 0) {
          imageObserver.disconnect()
        }
      }
    })
  }, { rootMargin: '400px' })

  images.forEach(image => imageObserver.observe(image))
}

export function loadImage (elem) {
  if (elem.hasAttribute('data-bg-img')) {
    elem.style.backgroundImage = `url(${elem.getAttribute('data-bg-img')})`
  } else if (elem.hasAttribute('data-img')) {
    if (elem.hasAttribute('data-srcset')) {
      elem.srcset = `${elem.getAttribute('data-srcset')}`
    }
    elem.src = `${elem.getAttribute('data-img')}`
  }

  elem.classList.remove('lazy')
}
